import React, { createContext, useState, useContext, useCallback } from 'react';

const SoundContext = createContext();

export const useSound = () => useContext(SoundContext);

export const SoundProvider = ({ children }) => {
  const [isSoundEnabled, setIsSoundEnabled] = useState(true); // Sound enabled by default

  const playSound = useCallback((soundName) => {
    if (isSoundEnabled) {
      const audio = new Audio(process.env.PUBLIC_URL + `/sounds/${soundName}.mp3`);
      audio.play().catch(e => console.error("Error playing sound:", e));
    }
  }, [isSoundEnabled]);

  const toggleSound = useCallback(() => {
    setIsSoundEnabled(prev => !prev);
  }, []);

  const value = {
    isSoundEnabled,
    playSound,
    toggleSound,
  };

  return (
    <SoundContext.Provider value={value}>
      {children}
    </SoundContext.Provider>
  );
};
